<template>
  <div>
    <div v-if="benefitForms.length" class="mt-3">
      <div>{{ dictionary.benefitDateRanges.name }}:</div>

      <ul class="mt-1">
        <li v-for="(benefitForm, index) in benefitForms" :key="index" class="mt-1">
          {{ getBenefitType(benefitForm.type) }}: {{ benefitForm.startDate | moment('DD-MM-YYYY') }} -
          {{ benefitForm.endDate | moment('DD-MM-YYYY') }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { DecisionCalculationType } from '@/enums/decisionCalculationType';
import { PublicSettings } from '@/enums/publicSettings.enum';

// @vuese
// Szczegóły decyzji dla wprowadzania faktur
// @group invoice
export default {
  props: {
    decision: {
      type: Object,
      required: true
    }
  },
  computed: {
    benefitForms() {
      return this.decision.dataDateRanges?.benefitDateRanges || [];
    },
    withdrawalPeriods() {
      return this.decision.dateRanges.filter(dataRange => dataRange.type === DecisionCalculationType.WITHDRAWAL);
    },
    holdPeriods() {
      return this.decision.dateRanges.filter(dataRange => dataRange.type === DecisionCalculationType.HOLD);
    },
    ...mapState({
      dictionary: state =>
        JSON.parse(state.setting.settings[PublicSettings.DECISION_DATA_DATES_DICTIONARY]?.value || '{}')
    })
  },
  methods: {
    // @vuese
    // Wyszukuje nazwe świadczenia
    getBenefitType(value) {
      return this.dictionary.benefitDateRanges.types.find(type => type.value === value).text;
    }
  }
};
</script>
